// https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
export const rgbToHex = (r: number, g: number, b: number) =>
  '#' +
  [r, g, b]
    .map(x => {
      const hex = x.toString(16);
      return hex.length === 1 ? '0' + hex : hex;
    })
    .join('');

export const hexToRgb = (hex: string): IRGB => {
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      }
    : { r: 0, g: 0, b: 0 };
};

interface IRGB {
  readonly r: number;
  readonly g: number;
  readonly b: number;
}

const limitIntensisty = (value: number) => {
  if (value > 255) {
    return 255;
  } else if (value < 0) {
    return 0;
  } else {
    return value;
  }
};

export class Color {
  private rgb: IRGB;
  public constructor(private hexString: string) {
    this.rgb = hexToRgb(hexString);
  }

  public IsDark = () => {
    // YIQ equation from http://24ways.org/2010/calculating-color-contrast
    const { r, g, b } = this.rgb;
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq < 128;
  };

  public GetLighterHex = (ratio: number) => {
    const { r, g, b } = this.rgb;
    const amount = 255 * ratio;
    const rgb: IRGB = {
      r: limitIntensisty(r + amount),
      g: limitIntensisty(g + amount),
      b: limitIntensisty(b + amount)
    };
    return rgbToHex(rgb.r, rgb.g, rgb.b);
  };

  public GetDarkerHex = (ratio: number) => {
    const { r, g, b } = this.rgb;
    const amount = 255 * ratio;
    const rgb: IRGB = {
      r: limitIntensisty(r - amount),
      g: limitIntensisty(g - amount),
      b: limitIntensisty(b - amount)
    };
    return rgbToHex(rgb.r, rgb.g, rgb.b);
  };
}
